/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Add_EmailInputs */

const en_profile_add_email = /** @type {(inputs: Profile_Add_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add an email to personalize your account`)
};

const es_profile_add_email = /** @type {(inputs: Profile_Add_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agrega un correo para personalizar tu cuenta`)
};

/**
* | output |
* | --- |
* | "Add an email to personalize your account" |
*
* @param {Profile_Add_EmailInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const profile_add_email = /** @type {((inputs?: Profile_Add_EmailInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Add_EmailInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_profile_add_email(inputs)
	return en_profile_add_email(inputs)
});